import React, { useState } from "react";
import "./popupbox.css";

function Popupboxx({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, message } = formData;
    const phoneNumber = "918778934301"; // WhatsApp number with country code

    const text = `Hello Electiaa Team,%0A%0A*Name:* ${name}%0A*Email:* ${email}%0A*Phone:* ${phone}%0A*Message:* ${message}%0A%0APlease get in touch with me regarding website design services.`;

    window.open(`https://wa.me/${phoneNumber}?text=${text}`, "_blank");

    setFormData({ name: "", email: "", phone: "", message: "" });
    onClose(); // close popup after submit
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay" onClick={onClose}></div>
      <div className="popup-form">
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>
       {/* <div className="header-form"> */}
          <center><h2>Get in Touch</h2></center>
          <br></br>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button className="choose-plan-btn" type="submit">
              Send Message
            </button>
          </form>
        </div>
      {/* </div> */}
    </>
  );
}

export default Popupboxx;
